import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-black font-heading text-foreground-950 mb-4">
          不错过任何大瓜
        </h2>
        <p className="text-base md:text-lg text-foreground-600 mb-8">
          每日聚合 51黑料、91黑料、网曝猛料，一手资讯最先送达
        </p>
        <Link
          to="/category/mengliao"
          className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold rounded-full bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          立即开吃
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}